import { render, staticRenderFns } from "./pl-scroll-option-item.vue?vue&type=template&id=06b94606&"
import script from "./pl-scroll-option-item.vue?vue&type=script&lang=js&"
export * from "./pl-scroll-option-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports